<div class="discussion-list">
  <!-- Empty State -->
  <div *ngIf="discussions.length === 0" class="discussion-list--empty">
    <p class="discussion-list--empty-message">No Discussion Found</p>
  </div>

  <!-- Discussion Items -->
  <div 
    *ngFor="let discussion of discussions" 
    class="discussion-item"
    [class.pinned]="discussion.isPinned"
    [class.bookmarked]="discussion.isBookmarked"
    (click)="navigateToDiscussion(discussion.id)"
  >
    <div class="discussion-item--content">
      <!-- Row 1: Title (left) | Type badge + category chip (right) -->
      <div class="discussion-item--row discussion-item--row-top">
        <div class="discussion-item--title-group">
          <h4 class="discussion-item--title">{{ discussion.title }}</h4>
          <span 
            class="discussion-item--tag discussion-item--tag-status" 
            [class.discussion-item--tag-status-pending]="discussion.status === 'PENDING' || discussion.status === 'CHANGES_REQUIRED'"
            [class.discussion-item--tag-status-rejected]="discussion.status === 'REJECTED'"
            *ngIf="!hideStatusBadge && discussion.statusLabel">{{ discussion.statusLabel }}</span>
        </div>
        <div class="discussion-item--tags-right" *ngIf="discussion.discussionType || discussion.category">
          <span
            class="discussion-item--tag discussion-item--tag-discussion-type discussion-item--tag-inline"
            *ngIf="discussion.discussionType"
          >{{ getDiscussionTypeDisplayLabel(discussion.discussionType) }}</span>
          <span class="discussion-item--tag discussion-item--tag-category discussion-item--tag-inline" *ngIf="discussion.category">{{ getCategoryDisplayLabel(discussion.category) }}</span>
        </div>
      </div>
      <!-- Row 2: author -->
      <div class="discussion-item--row discussion-item--row-bottom">
        <div class="discussion-item--meta-group">
          <span class="discussion-item--author-name">{{ discussion.author }}</span>
        </div>
      </div>
      <!-- Row 3: timestamp | delete (owner) | arrow -->
      <div class="discussion-item--row discussion-item--row-stats">
        <div class="discussion-item--stats-group">
          <span class="discussion-item--timestamp">{{ discussion.formattedDate || formatRelativeTime(discussion.lastActivity) }}</span>
        </div>
        <div class="discussion-item--actions-right">
          <button
            *ngIf="showDeleteForOwner && (!showEditOnlyForChangesRequired || discussion.status === 'CHANGES_REQUIRED' || discussion.status === 'PENDING')"
            class="discussion-item--action-btn discussion-item--edit-btn"
            aria-label="Edit discussion"
            type="button"
            (click)="onEditClick($event, discussion)"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
              <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
            </svg>
          </button>
          <button
            *ngIf="showDeleteForOwner"
            class="discussion-item--action-btn discussion-item--delete-btn"
            aria-label="Delete discussion"
            type="button"
            (click)="onDeleteClick($event, discussion)"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/>
              <line x1="10" y1="11" x2="10" y2="17"/>
              <line x1="14" y1="11" x2="14" y2="17"/>
            </svg>
          </button>
          <button class="discussion-item--arrow" aria-label="View discussion" type="button" (click)="navigateToDiscussion(discussion.id); $event.stopPropagation()">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
